import Layout from "../../Internal/Layout.vue";
import News from "./News.vue";
import AddNews from "./AddNews.vue";
import SeeNews from "./components/SeeNews.vue";

const NewsRoutes = {
  component: Layout,
  children: [
    {
      path: "/noticias",
      name: "News",
      component: News,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
    {
      path: "/cadastrar-noticia",
      name: "AddNews",
      component: AddNews,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
    {
      path: "/noticia",
      name: "SeeNews",
      component: SeeNews,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
        requiresResale: true,
      },
    },
  ],
};

export default NewsRoutes;
